"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useInitPixels = _interopRequireDefault(require("./useInitPixels"));

var _extendedLudaSnippet = _interopRequireDefault(require("./extendedLudaSnippet"));

var _vwoSnippet = _interopRequireDefault(require("./vwoSnippet"));

var _track = _interopRequireDefault(require("../../utils/track"));

var _appendInlineScript = _interopRequireDefault(require("./appendInlineScript"));

var _generateEAConfigureSnippet = _interopRequireDefault(require("./generateEAConfigureSnippet"));

var _usePixelsDebugPanel = _interopRequireDefault(require("../../utils/pixelmon/debug-panel/usePixelsDebugPanel"));

var _useRegisterDefaultContextPackers = _interopRequireDefault(require("./useRegisterDefaultContextPackers"));

var _debugPanel = _interopRequireDefault(require("./debug-panel"));

var _getWeSdkVersion = _interopRequireDefault(require("./getWeSdkVersion"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var EA_URL = 'https://d3425luerwqydx.cloudfront.net/ekoanalytics/master/latest/EkoAnalytics.min.gz.js';
/**
 * EkoAnalytics react component.
 * You must include this component on the page prior to using the `we-sdk/utils/track` function.

 * @export
 * @member module:components#EkoAnalytics
 * @type {React.Component}
 * @param {object} props
 * @param {string} props.appId - Required. appId of the application - as handled in the cms, zuri, etc. (Used for analytics)
 * @param {boolean} props.isProduction - Required. True if currently running on production environment, false otherwise.
 * @param {boolean} [props.projectId] - Optional. If this page owns an <EkoVideo> component, this is its projectId. (Used for analytics)
 * @param {boolean} [props.isKidsContent] - Optional. True if app is targeted towards kids (under COPPA). Default is false. _**NOTE:** when rendering EkoAnalytics, only the initial value of isKidsContent is considered. Runtime changes to `isKidsContent` do not have any effect._
 * @param {boolean} [props.forcePixelsEnabled] - Optional. Activate pixelmon and fire pixels in response to track() events, regardless of the value of isKidsContent. Default is false.
 * @param {boolean} [props.vwoEnabled] - Optional. When true, VWO testing will be initialized and enabled. Passing false would disable VWO. Default true.
 */

var EkoAnalytics = function EkoAnalytics(_ref) {
  var appId = _ref.appId,
      isProduction = _ref.isProduction,
      projectId = _ref.projectId,
      isKidsContent = _ref.isKidsContent,
      forcePixelsEnabled = _ref.forcePixelsEnabled,
      _ref$vwoEnabled = _ref.vwoEnabled,
      vwoEnabled = _ref$vwoEnabled === void 0 ? true : _ref$vwoEnabled,
      _ref$useLocalDefaultF = _ref.useLocalDefaultFields,
      useLocalDefaultFields = _ref$useLocalDefaultF === void 0 ? false : _ref$useLocalDefaultF;

  var _useState = (0, _react.useState)(typeof window !== 'undefined' && typeof window.EkoAnalytics === 'function' && window.EkoAnalytics('getUid')),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      userId = _useState2[0],
      setUserId = _useState2[1];

  var _useState3 = (0, _react.useState)(typeof window !== 'undefined' && typeof window.EkoAnalytics === 'function' && window.EkoAnalytics('getSid')),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      sessionId = _useState4[0],
      setSessionId = _useState4[1];

  var _useState5 = (0, _react.useState)(typeof window !== 'undefined' && typeof window.EkoAnalytics === 'function' && window.EkoAnalytics('getPageViewId')),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      pageViewId = _useState6[0],
      setPageViewId = _useState6[1];

  (0, _react.useEffect)(function () {
    // By the time we execute this useEffect() hook, we had already rendered some script tags (luda + vwo).
    // If they did not run (i.e. we're using plain React with no SSR), we must append them again ASAP.
    var renderedScriptsWereNotExecuted = typeof window !== 'undefined' && !window.EkoAnalytics;

    if (renderedScriptsWereNotExecuted) {
      (0, _appendInlineScript["default"])(_extendedLudaSnippet["default"]);

      if (vwoEnabled) {
        (0, _appendInlineScript["default"])(_vwoSnippet["default"]);
      } // Re set the global fields


      setUserId(window.EkoAnalytics('getUid'));
      setSessionId(window.EkoAnalytics('getSid'));
      setPageViewId(window.EkoAnalytics('getPageViewId'));
    } // We want the following script tag to only be added after hydration.
    // This is in order to support server side rendering (SSR), where the isProduction prop might be passed as:
    // isProduction={typeof window !== 'undefined' && window.location.hostname === 'myproductiondomain.com'}
    // Otherwise, since the above expression evaluates to false on SSR (no window),
    // EkoAnalytics would be configured with `isProduction: false` even when we want it to be true.


    (0, _appendInlineScript["default"])((0, _generateEAConfigureSnippet["default"])({
      isProduction: isProduction,
      isKidsContent: isKidsContent,
      appId: appId,
      projectId: projectId,
      EA_URL: EA_URL
    }));
  }, [appId, projectId, isProduction, isKidsContent, vwoEnabled]);
  (0, _useRegisterDefaultContextPackers["default"])(projectId); // Track "we-sdk.init", once, as soon as we can (as soon as EkoAnalytics exists on the page)
  // this also allows us to setup pixels to use event "we-sdk.init" - which is like an "asap" event

  (0, _react.useEffect)(function () {
    (0, _track["default"])('we-sdk.init');
  }, []);
  (0, _useInitPixels["default"])(appId, isKidsContent, forcePixelsEnabled, projectId, userId, sessionId, pageViewId);
  var pixelsDebugPanel = (0, _usePixelsDebugPanel["default"])(projectId, appId, (0, _getWeSdkVersion["default"])());
  var eaDebugPanel = (0, _debugPanel["default"])((0, _getWeSdkVersion["default"])(), useLocalDefaultFields); // Important note - this is returned and rendered immediately (before any useEffect hooks are run) in order to support SSR,
  // where the <script> tags would be rendered into the initial state of a static HTML file.
  // However, if SSR is not used, and plain React is used, these scripts will not run because React internally sets the script code using innerHTML,
  // which browsers do not execute due to security concerns.

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, pixelsDebugPanel, eaDebugPanel, /*#__PURE__*/_react["default"].createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: _extendedLudaSnippet["default"]
    }
  }), vwoEnabled && /*#__PURE__*/_react["default"].createElement("script", {
    type: "text/javascript",
    dangerouslySetInnerHTML: {
      __html: _vwoSnippet["default"]
    }
  }));
};

var _default = EkoAnalytics;
exports["default"] = _default;